import React from 'react';
import { Chip, Tooltip, Typography, Box } from '@mui/material';

const STYLES = {
  excellent: { color: 'success', emoji: '🟢' },
  good: { color: 'success', emoji: '🟢' },
  needs_attention: { color: 'warning', emoji: '🟡' },
  poor: { color: 'error', emoji: '🔴' },
};

export default function HealthBadge({ healthStatus, healthLabel, size = 'small' }) {
  if (!healthStatus || !healthLabel) return null;
  const s = STYLES[healthStatus] || STYLES.good;
  return (
    <Chip
      size={size}
      label={`${s.emoji} ${healthLabel}`}
      color={s.color}
      variant="outlined"
      sx={{ fontWeight: 600 }}
    />
  );
}

export function HealthLegendTooltip({ children }) {
  return (
    <Tooltip
      title="Excellent / Good = on track. Needs attention = review soon. Poor = action needed."
      arrow
    >
      <span>{children}</span>
    </Tooltip>
  );
}

export function formatCurrency(amount, currency = 'INR') {
  const n = Number(amount) || 0;
  try {
    return new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency,
      maximumFractionDigits: 0,
    }).format(n);
  } catch (_) {
    return `${currency} ${n.toLocaleString()}`;
  }
}

export function SectionTitle({ title, help }) {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mb: 2 }}>
      <Typography variant="h6" component="h2">
        {title}
      </Typography>
      {help}
    </Box>
  );
}
